import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const testimonials = [{
  name: 'Mariana G.',
  meta: 'Buenos Aires · Diseñadora, 34 años',
  text: 'Tenía dolor lumbar hace 3 años. Con la primera semana de rutinas sentí una diferencia enorme. Ahora lo hago todas las mañanas y dejé de tomar ibuprofeno. No lo puedo creer todavía.'
}, {
  name: 'Lucas R.',
  meta: 'Córdoba · Programador, 29 años',
  text: 'El módulo de cervicales fue un antes y un después. Trabajo 10 horas frente a la computadora y llegaba a casa con el cuello destruido. En dos semanas cambió todo. Ahora termino el día mucho mejor.'
}, {
  name: 'Carolina V.',
  meta: 'Mendoza · Docente, 47 años',
  text: 'Tenía miedo de hacer ejercicio por el dolor de rodilla. Este programa me enseñó a moverme bien. Ya bajo las escaleras sin molestias. Algo que parecía imposible hace 3 meses.'
}, {
  name: 'Roberto M.',
  meta: 'Rosario · Administrativo, 52 años',
  text: 'Me despertaba todas las mañanas con el cuerpo rígido. Pensaba que era normal con la edad. Ahora entiendo que no lo era. El programa me devolvió la sensación de tener un cuerpo que responde.'
}];
export function Testimonials() {
  return <Section id="testimonios" bg="bg-white" data-id="element-181" data-mp="1eteabqp1b1ij">
      <Reveal data-id="element-182" data-mp="1eufpo7d32a62">
        <SectionHeading title="Esto dicen quienes ya lo hicieron" data-id="element-183" data-mp="1euz59hf9gmgx" />
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-184" data-mp="2bivd9xwmu9gj">
        {testimonials.map((t, i) => <Reveal key={t.name} index={i} data-id="element-185" data-mp="26llomkh2i1tr" data-mpi={i}>
            <figure className="flex h-full flex-col rounded-2xl border border-sand-200 bg-sand-50 p-6" data-id="element-186" data-mp="22ip4gpbvpxnp">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-187" data-mp="1xjm6foubgrp8">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-clay-500 text-clay-500" data-id="element-188" data-mp="r4l8xepn81gj" data-mpi={s} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[0.975rem] leading-relaxed text-forest-700/85" data-id="element-189" data-mp="m35pfr346309">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-5 border-t border-sand-200 pt-4" data-id="element-190" data-mp="sl8uu5y17zvi">
                <p className="font-semibold text-forest-800" data-id="element-191" data-mp="eky5568gkrbx">{t.name}</p>
                <p className="text-sm text-forest-700/60" data-id="element-192" data-mp="ekoedgflag56">{t.meta}</p>
              </figcaption>
            </figure>
          </Reveal>)}
      </div>
    </Section>;
}